import React from 'react';
import styled from 'styled-components';
import SuperAdminMemberManagementComponent from 'Components/SuperAdminPage/SuperAdminMemberManagement';
import { SuperAdminLayout } from 'Components/Layout/SuperAdminLayout';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const SuperAdminMemberManagement = () => {
  return (
    <SuperAdminLayout>
      <ContentContainer>
        <SuperAdminMemberManagementComponent />
      </ContentContainer>
    </SuperAdminLayout>
  );
};
export default SuperAdminMemberManagement;
